import { Kind } from 'graphql';
const isExtensionNode = (def) => def.kind === Kind.OBJECT_TYPE_EXTENSION ||
    def.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    def.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION ||
    def.kind === Kind.UNION_TYPE_EXTENSION ||
    def.kind === Kind.ENUM_TYPE_EXTENSION ||
    def.kind === Kind.SCALAR_TYPE_EXTENSION ||
    def.kind === Kind.SCHEMA_EXTENSION;
export function filterAndExtractExtensionDefinitions(ast) {
    const extensionDefs = [];
    const typesDefs = [];
    ast.definitions.forEach(def => {
        if (isExtensionNode(def)) {
            extensionDefs.push(def);
        }
        else {
            typesDefs.push(def);
        }
    });
    return {
        typesAst: {
            ...ast,
            definitions: typesDefs,
        },
        extensionsAst: {
            ...ast,
            definitions: extensionDefs,
        },
    };
}
export function filterExtensionDefinitions(ast) {
    const { typesAst } = filterAndExtractExtensionDefinitions(ast);
    return typesAst;
}
export function extractExtensionDefinitions(ast) {
    const { extensionsAst } = filterAndExtractExtensionDefinitions(ast);
    return extensionsAst;
}
//# sourceMappingURL=extensionDefinitions.js.map